import React from 'react';
import {defaultProps} from 'recompose';

import {translate} from 'iss/strings';
import {useRoutes} from 'iss/hooks/useRoutes';
import BootstrapButton from 'iss/widgets/bootstrap/Button';
import GlyphIcon from 'iss/widgets/bootstrap/GlyphIcon';

/** A basic multi purpose button with optional support for glyphs and linking to routes
 * optional props:
 *
 * link: a URL that can be routed by the app router. A link changes the html element of the button to "a"
 * onClick: a handler for click events
 * icon: A glyphicon icon name, for example "search". (See https://getbootstrap.com/docs/3.3/components/#glyphicons)
 * alt: Alternate text for the icon
 * text or children: Text or child components to display in the button
 * buttonLook: default, primary, successs, danger, warning, or link
 * size: can be lg, sm, xs to make the button larger or smaller
 * type: button type, defaults to "button", is not applied if link is supplied
 * className: class name
 *
 **/
export function Button({link, onClick, icon, alt, text, children, ...props}) {
  const {history} = useRoutes();

  function goToLink(e) {
    e.preventDefault();
    history.push(link);
    onClick && onClick();
  }
  return <BootstrapButton onClick={link ? goToLink : onClick}
    component={link ? "a" : "button"}
    href={link || undefined}
    title={alt} {...props}>
    {alt && <span className="sr-only">{alt}</span>}
    {icon && <GlyphIcon icon={icon} />}
    {text || children}
  </BootstrapButton>;
}

export const NewButton = defaultProps({id: 'new-item', buttonLook: "primary"})(Button);
export const SubmitButton = defaultProps({id: 'proceed', buttonLook: "primary", type: "submit"})(Button);
export const CancelButton = defaultProps({text: translate('common.cancel'), id: 'cancel'})(Button);
export const RemoveButton = defaultProps({id: 'remove', alt: translate('common.remove'), buttonLook: 'danger', icon: 'remove'})(Button);
export function EditButton({canEdit = true, ...props}) {
  return <Button buttonLook={canEdit ? "primary" : "default"}
    icon={canEdit ? "pencil":"search"}
    {...props} />;
}
export const ActionButton = defaultProps({id: 'action', buttonLook: 'primary'})(Button);



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/Buttons.jsx